import React from "react";
import { PlusLink } from "@clarkinc/zest-design-system";
import spritePath from "~/common/Icon/critical-symbol.svg";
export enum RibbonType {
  Good = "Good",
  Better = "Better",
  Best = "Best",
  Plus = "Plus",
  FreeShipping = "Free Shipping",
}
interface Props {
  ribbonType: RibbonType;
  adjacentBanner: boolean;
}
const Ribbon = ({
  ribbonType,
  adjacentBanner
}: Props) => {
  return <>
      {ribbonType === RibbonType.Plus ? <PlusLink iconProps={{
      spriteSheetHref: spritePath
    }} linkProps={{
      className: "inline-flex ml-1",
      rel: ""
    }} /> : <span className={`
            ${ribbonType === RibbonType.Good ? "bg-goodBrown-100 text-black font-semibold" : ""}
            ${ribbonType === RibbonType.Better ? "bg-betterGray-100 text-black font-semibold" : ""}
            ${ribbonType === RibbonType.Best ? "bg-bestYellow-100 text-black font-semibold" : ""}
            ${ribbonType === RibbonType.FreeShipping ? "bg-blue-800 text-shadow-200 font-normal" : ""}
            ${adjacentBanner ? "ml-1" : ""}
            rounded-tl
            rounded-br
            rounded-tr-xs
            rounded-bl-xs
            border-0
            table
            text-xs
            leading-3-1/2
            mb-2
            py-1/2
            pr-2
            pl-2
            align-middle
            w-auto
            transform
            -skew-x-15
            skew-y-0
            text-white
          `}>
          <span className="block transform skew-x-15 skew-y-0">
            {ribbonType}
          </span>
        </span>}
    </>;
};
export default Ribbon;